__webpack_require__.p = "https://test.battleplatform.ch/";